<div id="no-data">{{noDataText}}</div>
